module.exports = __webpack_public_path__ + "img/colazione_3.bcbaf7cc.jpeg";